import { initMap, equalCols, getCookie } from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {

	const vehicleViewModule = {
        isLoading: false,
        init() {
            $(document).on('click', '.broker-show-agent-phone', this, this.showPhoneNumber);
            $(document).on('click', '.vehicle-lead-send-btn', this, this.send);
        },
		showPhoneNumber(event) {
			const _this = event.data;
			event.preventDefault();

            var phone = $(this).data('text');
            $(this).find('span').text(phone);
            $(this).attr('href', 'tel:'+phone);
            $(this).removeClass('broker-show-agent-phone');
		},
		send(event) {
			const _this = event.data;
			event.preventDefault();
            var element = this;

            var id = $(element).data('id');
            if (!id) {
                Swal.fire({
                    text: 'Invalid item ID!'
                });
                return false;
            }

            $('.item-lead-form').find('.form-control').removeClass('is-invalid');
            $('.item-lead-form').find('.form-check-input').removeClass('is-invalid');
            
            var errors = false;

            if ($('#iten_lead_first_name').val() == '') {
                $('#item_lead_first_name').addClass('is-invalid');
                errors = true;
            }
            if ($('#item_lead_last_name').val() == '') {
                $('#item_lead_last_name').addClass('is-invalid');
                errors = true;
            }
            if ($('#item_lead_email').val() == '') {
                $('#item_lead_email').addClass('is-invalid');
                errors = true;
            }
            if ($('#item_lead_phone').val() == '') {
                $('#item_lead_phone').addClass('is-invalid');
                errors = true;
            }
            if (!$('#item_lead_terms_and_conditions').is(":checked")) {
                $('#item_lead_terms_and_conditions').addClass('is-invalid');
                errors = true;
            }

            if (errors) {
                return false;
            }

            //Loading...
            _this.isLoading = true;
			$(element).find('i').show();

            var values = '_token=' + encodeURIComponent($('meta[name="csrf-token"]').attr("content"));
            values += '&id=' + encodeURIComponent(id);
            values += '&first_name=' + encodeURIComponent($('#item_lead_first_name').val());
            values += '&last_name=' + encodeURIComponent($('#item_lead_last_name').val());
            values += '&email=' + encodeURIComponent($('#item_lead_email').val());
            values += '&phone=' + encodeURIComponent($('#item_lead_phone').val());
            values += '&company=' + encodeURIComponent($('#item_lead_company').val());
            values += '&message=' + encodeURIComponent($('#item_lead_message').val());
            values += '&newsletter=' + encodeURIComponent(($('#item_lead_newsletter').is(":checked")?1:0));
            $.ajax({
                type: "POST",
                url: baseURL + "/vehicle/lead",
                data: values,
                success: function(response) {
                    _this.isLoading = false;
                    $(element).find('i').hide();

                    if (response.status == 0) {
                        var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#item_lead_"+errorKey).addClass('is-invalid');
                                errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                        }

                        Swal.fire({
                            html: response.message+"<br>"+errorHtml
                        });

                        return false;
                    }

                    if (response.status == 1) {

                        $('.item-lead-form').find('.form-control').val('');
                        $('.item-lead-form').find('.form-check-input').attr('checked', false);

                        Swal.fire({
                            text: response.message
                        });

                        return;
                    }

                    Swal.fire({
                        text: response.message
                    });
                },
                error: function() {
                    _this.isLoading = false;
                    $(element).find('i').hide();
                }
            });

		}
    };

    const vehicleListingModule = {
        isLoading: false,
        currentXhr: null,
        observer: null,

        init() {
            this.attachObserver();
        },

        attachObserver() {
            const sentinel = document.getElementById('vehicles-load-more');
            if (!sentinel || !('IntersectionObserver' in window)) return;

            if (this.observer) this.observer.disconnect();

            this.observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) this.loadMore();
                });
            }, { rootMargin: '400px 0px' });

            this.observer.observe(sentinel);
        },

        loadMore() {
            if (this.isLoading) return;
            const $sentinel = $('#vehicles-load-more');
            if ($sentinel.attr('data-has-more') != '1') return;

            const nextPage = parseInt($sentinel.attr('data-next-page'), 10);
            this.fetchPage(nextPage);
        },

        fetchPage(page) {
            if (this.currentXhr) this.currentXhr.abort();

            this.isLoading = true;
            const $sentinel = $('#vehicles-load-more');
            const $spinner = $sentinel.find('.vehicles-load-more-spinner');
            $spinner.show();

            const url = new URL(window.location.href);
            url.searchParams.set('page', page);

            this.currentXhr = $.ajax({
                url: url.toString(),
                type: 'GET',
                dataType: 'json',
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                success: (response) => {
                    $('#vehicles-items-grid').append(response.html);

                    $sentinel.attr('data-next-page', response.nextPage);
                    $sentinel.attr('data-has-more', response.hasMore ? 1 : 0);
                    $sentinel.toggle(!!response.hasMore);

                    $spinner.hide();
                    this.isLoading = false;
                    this.currentXhr = null;
                },
                error: (xhr) => {
                    if (xhr.statusText === 'abort') return;
                    $spinner.hide();
                    this.isLoading = false;
                    this.currentXhr = null;
                }
            });
        }
    };

    if ($('#vehicles-items-container').length) {
        vehicleListingModule.init();
    }

    if ($('.vehicles-page-container').length) {
        vehicleViewModule.init();
    }
});
